module.exports = __webpack_public_path__ + "img/d200705a-1.9835b1cd.jpg";